<template>
	<div class="container student-container">
		<transition :name="componentTransition">
			<component :is="currentPage" class="student-page"></component>
		</transition>
	</div>
</template>

<script>
	import * as extend from 'extend'

	import ConnectPage from './flow/0-connect'
	import LobbyPage from './flow/1-lobby'
	import GamePage from './flow/2-game'
	import RoleplayPage from './flow/3-roleplay'

	import {ConsoleLogger} from '@/console-logger'
	import {$eBus} from '@/event-bus'

	import * as MutationTypes from '@/store/mutation-types'

	import GameClientEvent from '@/enum/GameClientEvent'
	import GamePhase from '@/enum/GamePhase'
	import GameType from '@/enum/GameType'
	import GameClientType from '@/enum/GameClientType'
	import AppConfig from '@/app-config'
	import {getStudentUrl} from '@/utils/UrlUtil'

	const pageComponents = {
		'connect': ConnectPage,
		'lobby': LobbyPage,
		'game': GamePage,
		'roleplay': RoleplayPage
	}

	const components = {}

	export default {
		components: extend(components, pageComponents),
		data() {
			return {
				componentTransition: AppConfig.componentTransition,
				currentPage: 'connect',
				logger: new ConsoleLogger('StudentController', 'background: #00aaaa; color: white', null,
					!AppConfig.debug.studentController),
			}
		},
		watch: {
			'$route'(to, from) {
				this.reloadCurrentPage(to)
			}
		},
		methods: {
			onRoomStateChanged(room) {
				let roomState = room && room.state ? room.state : {}

				if (roomState.hasOwnProperty('currentPageIndex') && roomState.currentPageIndex >= 0) {
					this.$store.commit(MutationTypes.SET_CURRENT_PAGE_INDEX, roomState.currentPageIndex)
				}

				if (roomState.hasOwnProperty('pagePhase')) {
					this.$store.commit(MutationTypes.SET_CURRENT_PAGE_PHASE, roomState.pagePhase)
				}

				if (roomState.hasOwnProperty('phase')) {
					if (roomState.phase === GamePhase.Lobby) {
						if (roomState.pageType !== 'roleplay') {
							// Roleplay always stays in lobby, so let's not redirect if you're here

							if (this.$route.path != getStudentUrl('lobby')) {
								this.$router.push(getStudentUrl('lobby'));
							}
						}
					}
				}
			},
			onRoomLeft(room) {
				if (this.$route.path != getStudentUrl('connect')) {
					this.$router.push(getStudentUrl('connect'));
				}
			},
			reloadCurrentPage(route) {
				let currentPage = route.params.page

				if (!currentPage || !components.hasOwnProperty(currentPage)) {
					this.logger.logMessage(`Unknown StudentPage "${currentPage}"`)

					this.$router.push(getStudentUrl('connect'))

					return
				}

				this.logger.logMessage(`StudentPage changed to "${currentPage}"`)

				this.currentPage = currentPage
			}
		},
		mounted() {
			this.$store.commit(MutationTypes.SET_GAME_CLIENT_TYPE, GameClientType.Online);
			this.$store.commit(MutationTypes.SET_GAME_TYPE, GameType.ClassRoom);

			$eBus.$on(GameClientEvent.RoomStateChange, this.onRoomStateChanged)
			$eBus.$on(GameClientEvent.RoomLeave, this.onRoomLeft)

			this.reloadCurrentPage(this.$router.currentRoute)
		},
		beforeDestroy() {
			$eBus.$off(GameClientEvent.RoomStateChange, this.onRoomStateChanged)
			$eBus.$off(GameClientEvent.RoomLeave, this.onRoomLeft)
		}
	}
</script>
<style lang="less" scoped>
	.student-container {
		position: relative;
		height: 100%;
		width: 100%;
	}

	.student-page {
		text-align: center;
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
	}
</style>
